module.exports = __webpack_public_path__ + "images/category_lp/macbook/assessment_achievements/3@2x_33f92adff748e84e34052f02c9a0cadd.png";